export default __webpack_public_path__ + "static/media/course-card-background.b6e2a866.png";